import { ThemeProvider, createTheme } from '@material-ui/core';
import PropTypes from 'prop-types';
import React, { Component, Suspense } from 'react';
import ReactGA from 'react-ga';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import BeatLoader from 'react-spinners/BeatLoader';
import DashboardPage from './pages/DashboardPage';
import DiscoverPage from './pages/DiscoverPage';
import EmailTemplatePage from './pages/EmailTemplatePage';
import FileUpload from './features/file-upload/FileUpload';
import FreeCouponPage from './pages/FreeCouponPage';
import RegisterInCategoryTwoSteps from './features/login/components/register/RegisterInCategoryTwoSteps';
import LoginInfloPage from './features/login/components/login/LoginInfloPage';
import ResetPasswordPage from './pages/reset-password-page';
import LogoutPage from './pages/LogoutPage';
import NotFoundPage from './pages/NotFoundPage';
import FlagsPage from './pages/FlagsPage';
import RegisterOnBoardingPage from './pages/RegisterOnBoardingPage';
import MediaPlayer from './features/player/components/MediaPlayer';
import FlagsMediaPlayer from './features/player/components/FlagsMediaPlayer';
import ProfilePage from './pages/ProfilePage';
import { default as config } from './constants/constants';
import withAuthentication from './session/with_authentication';
import OpenstaxPage from './pages/OpenstaxPage';
import PdfViewerPage from './pages/PdfViewerPage';
import RouteChangeListener from './RouteChangeListener';

if (process.env.NODE_ENV !== 'test') {
  //bypass google analytics when running tests
  ReactGA.initialize(config.gaTrackingID, {
    debug: false
  });
}

class LocationListener extends Component {
  static contextTypes = {
    router: PropTypes.object
  };

  componentDidMount() {
    //const { t, i18n } = useTranslation()
    //i18n.changeLanguage("en");
    this.handleLocationChange(this.context.router.history.location);
    this.unlisten = this.context.router.history.listen(
      this.handleLocationChange
    );
  }

  componentWillUnmount() {
    this.unlisten();
  }

  handleLocationChange(location) {
    if (process.env.NODE_ENV !== 'test') {
      ReactGA.pageview(location.pathname);
    }
  }

  render() {
    return this.props.children;
  }
}

class App extends Component {
  render() {
    this.player = React.createRef();
    this.flagsPlayer = React.createRef();

    const theme = createTheme({
      typography: {
        fontFamily: 'Proxima Nova, sans-serif'
      }
    });

    return (
      <Suspense fallback={<BeatLoader color={'orange'} />}>
        <BrowserRouter basename={config.basename || ''}>
          <ThemeProvider theme={theme}>
            <LocationListener>
              <RouteChangeListener />

              <MediaPlayer ref={this.player} />
              <FlagsMediaPlayer ref={this.flagsPlayer} />
              <Switch>
                <Route exact path="/" component={LoginInfloPage} />
                <Route
                  exact
                  path="/registerOnCategory/:asu"
                  component={RegisterInCategoryTwoSteps}
                />
                <Route
                  exact
                  path="/registerOnBoarding/:code"
                  component={RegisterOnBoardingPage}
                />
                <Route exact path="/freetrial" component={FreeCouponPage} />
                <Route exact path="/discover" component={DiscoverPage} />
                <Route exact path="/dashboard" component={DashboardPage} />
                <Route exact path="/flags" component={FlagsPage} />
                <Route exact path="/myprofile" component={ProfilePage} />
                <Route exact path="/uploadPdf" component={FileUpload} />
                <Route exact path="/openstax" component={OpenstaxPage} />
                <Route exact path="/pdf-viewer" component={PdfViewerPage} />
                <Route
                  exact
                  path="/emailtemplate"
                  component={EmailTemplatePage}
                />
                <Route
                  exact
                  path="/passwordreset/:code"
                  component={ResetPasswordPage}
                />
                <Route exact path="/logout" component={LogoutPage} />
                {/*<Route exact path='/auth.html' component={AuthPage}/>*/}
                <Route component={NotFoundPage} />
              </Switch>
            </LocationListener>
          </ThemeProvider>
        </BrowserRouter>
      </Suspense>
    );
  }
}

export default withAuthentication(App);
